import cn from 'classnames';
import * as React from 'react';

import { ClosedCaptioning } from 'components/icons';
import OptionChildView, { OptionChildViewProps } from '../OptionChildView';
import { captionsViewBlock as block } from '../utils';
import CaptionsChildViewContents from './CaptionsChildViewContents';
import { CaptionsChildViewProvider } from './CaptionsChildViewContext';
import useCaptionsChildViewProps from './useCaptionsChildViewProps';

type PickedChildViewProps = Pick<
  OptionChildViewProps,
  'active' | 'onClose' | 'className'
>;

export interface CaptionsChildViewProps extends PickedChildViewProps {}

const CaptionsChildView: React.FC<CaptionsChildViewProps> = ({
  active,
  className,
  onClose,
}) => {
  const captionsChildViewProps = useCaptionsChildViewProps();

  return (
    <OptionChildView
      title="captions"
      icon={<ClosedCaptioning style={{ width: 24, height: 'auto' }} />}
      active={active}
      className={cn(className, block())}
      bodyClassName={block('body')}
      onClose={onClose}
    >
      <CaptionsChildViewProvider {...captionsChildViewProps}>
        <CaptionsChildViewContents />
      </CaptionsChildViewProvider>
    </OptionChildView>
  );
};

export default CaptionsChildView;
